<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()" class="alarms-search-dialog">
  <div class="search-container">
    <div class="search-column">
      <mat-form-field  *ngIf="type !== 'journal'">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="search.name" matInput>
      </mat-form-field>

      <mat-form-field  *ngIf="type === 'journal'">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="search.action" matInput>
      </mat-form-field>

      <mat-form-field  *ngIf="type === 'journal'">
        <mat-label>Operator</mat-label>
        <input [(ngModel)]="search.operator" matInput>
      </mat-form-field>

      <ac-input-container *ngIf="type !== 'journal'" label="Severity"   >
        <ac-select
          [(acModel)]="search.severity"
          [items]="search.severityOptions"
          [allowClear]="true"
          [multiple]="true"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container *ngIf="type === 'active'" label="Acknowledged"   >
        <ac-select
          [(acModel)]="search.isAcknowledged"
          [items]="search.acknowledgedOptions"
          [allowClear]="false"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <mat-form-field *ngIf="type !== 'journal'">
        <mat-label>Source</mat-label>
        <input [(ngModel)]="search.source" matInput>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Description</mat-label>
        <input [(ngModel)]="search.description" matInput>
      </mat-form-field>

      <mat-form-field *ngIf="type !== 'journal'">
        <mat-label>Additional Info</mat-label>
        <input [(ngModel)]="search.additionalInfo" matInput>
      </mat-form-field>

      <mat-form-field  *ngIf="type === 'journal'">
        <mat-label>Value</mat-label>
        <input [(ngModel)]="search.value" matInput>
      </mat-form-field>

      <div class="alarms-time">

        <mat-radio-group [(ngModel)]="search.alarmsTime" [ngModelOptions]="{standalone: true}">
          <mat-radio-button color="primary" value="noDates">All dates</mat-radio-button>
          <mat-radio-button color="primary" value="last24Hours" class="vertical">Last 24 hours</mat-radio-button>
          <mat-radio-button color="primary" value="last7Days" class="vertical">Last 7 days</mat-radio-button>
          <mat-radio-button color="primary" value="last30Days" class="vertical">Last 30 days</mat-radio-button>
          <mat-radio-button color="primary" value="betweenDates" class="fullWidth alarms-search-ac-picker">
            <div class="time-range-date-picker">
              <ac-date-picker [acModel]="search.date"
                              (acChanged)="onDatePick($event)"
                              startModelName="startDate"
                              endModelName="endDate"
                              openDirection="up"
                              [options]="datePickerOptions"
                              [ngDisabled]="search.alarmsTime !== 'betweenDates'"
                              alternativeName="alarmsTime">
              </ac-date-picker>
            </div>
          </mat-radio-button>
        </mat-radio-group>

      </div>
    </div>
  </div>
</arm-dialog>
